<template>
  <nav class="hrm_pagination themePaginate px-4 flex items-center justify-center sm:px-0 ">
    <div class="block">
      <button type="button" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)"
        class="hrm_prev_btn pre_Next flex items-center justify-center text-sm font-medium text-gray-500 hover:text-gray-700 w-fit h-8 px-3 py-1 rounded-l-lg bg-body"
        :class="{ 'opacity-30': currentPage <= 1 }">
        Previous
      </button>
    </div>
    <div class="flex">
      <button class="hrm_page_btn hidden md:block" type="button" @click="changePage(1)" :class="{
        'flex items-center justify-center text-sm font-medium w-8 h-8  hover:bg-gray-300 shadow-md': currentPage !== 1,
        'flex items-center justify-center text-sm font-medium w-8 h-8  activePage': currentPage === 1,
      }">
        1
      </button>
      <span v-if="startPage > 2"
        class="hrm_page_btn hrm_page_dots flex items-center justify-center text-sm font-medium w-8 h-8 bg-gray-200 hover:bg-gray-300">
        ...
      </span>
      <button class="hrm_page_btn md:hidden" type="button" :class="{
        'flex items-center justify-center text-sm font-medium w-8 h-8 bg-gray-200 hover:bg-gray-300 ': page !== currentPage,
        'flex items-center justify-center text-sm font-medium w-8 h-8  activePage': page === currentPage,
      }">
        {{ currentPage }}
      </button>
      <button class="hrm_page_btn hidden md:block" type="button" v-for="page in pages" :key="page"
        @click="changePage(page)" :class="{
          'flex items-center justify-center text-sm font-medium w-8 h-8 bg-gray-200 hover:bg-gray-300 ': page !== currentPage,
          'flex items-center justify-center text-sm font-medium w-8 h-8  activePage': page === currentPage,
        }">
        {{ page }}
      </button>
      <span v-if="endPage < lastPage - 1"
        class="hrm_page_btn hrm_page_dots flex items-center justify-center text-sm font-medium w-8 h-8 bg-gray-200 hover:bg-gray-300">
        ... </span>
      <button class="hrm_page_btn hidden md:block" type="button" @click="changePage(lastPage)" :class="{
        'flex items-center justify-center text-sm font-medium w-8 h-8 bg-gray-200 hover:bg-gray-300 ': currentPage !== lastPage,
        'flex items-center justify-center text-sm font-medium w-8 h-8  activePage': currentPage === lastPage,
      }">
        {{ lastPage }}
      </button>
    </div>
    <div class="block">
      <button type="button " :disabled="currentPage >= lastPage" @click="changePage(currentPage + 1)"
        class="hrm_next_btn  pre_Next flex items-center justify-center text-sm font-medium text-gray-500 hover:text-gray-700 w-fit h-8 px-3 py-1 rounded-r-lg"
        :class="{ 'opacity-50': currentPage >= lastPage }">
        Next
      </button>
    </div>
  </nav>
</template>

<script>
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from "@heroicons/vue/24/solid";

export default {
  components: {
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    lastPage: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    maxVisibleButtons: {
      type: Number,
      default: 7,
    },
  },
  computed: {
    startPage() {
      const minStart = 2;
      if (this.currentPage <= this.maxVisibleButtons) {
        return minStart;
      }
      return Math.min(this.currentPage - Math.floor(this.maxVisibleButtons / 2), this.lastPage - this.maxVisibleButtons + 1);
    },
    endPage() {
      const maxEnd = this.lastPage - 1;
      if (this.currentPage <= this.maxVisibleButtons) {
        return Math.min(this.maxVisibleButtons + 1, maxEnd);
      }
      return Math.min(this.currentPage + Math.floor(this.maxVisibleButtons / 2), maxEnd);
    },
    pages() {
      const range = [];
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push(i);
      }
      return range;
    },
  },
  methods: {
    changePage(page) {
      this.$emit("refreshTable", page);
    },
  },
};
</script>
<style>
/*paginate buttons*/
.hrm_pagination .hrm_prev_btn {
  background: #1f2123;
  border: 0;
}

.hrm_pagination .hrm_prev_btn,
.hrm_pagination .hrm_next_btn {
  padding: 8px 16px;
}

.hrm_pagination .hrm_next_btn,
.hrm_pagination .hrm_prev_btn,
.hrm_pagination .hrm_page_btn:not(.hrm_pagination .hrm_page_btn.hrm_page_dots) {
  background: #313439;
  border: 0;
  color: white;
  font-size: 12px;
}

.hrm_pagination .hrm_next_btn:hover:not(.hrm_pagination .hrm_next_btn:disabled) {
  background: var(--hrm_Theme_Bg_Color);
  color: var(--hrm_Theme_Text_Color);
}

.hrm_pagination .hrm_page_btn.activePage,
.hrm_pagination .hrm_page_btn:hover:not(.hrm_pagination .hrm_page_btn.hrm_page_dots) {
  background: var(--hrm_Theme_Bg_Color) !important;
  color: var(--hrm_Theme_Text_Color) !important;
}
</style>